import styled, { css } from "styled-components";
import { t } from "i18next";
import * as R from "ramda";

import { getScreenSize, getThemeColor, getThemeFont, getThemeSize } from "../../../utils/theme";
import { Text } from "../common";
import { DisplayFlexS } from "../../../utils/stylesHelpers";

import NoLogoIcon from '../../assets/imgs/icons/NOlogo_Icon.svg';

export const ComponentProfileWrapS = styled.div`
  margin: 20px auto 0 auto;
  
  width: ${getScreenSize(['tabletPC'])}
  
  
  @media (max-width: ${getScreenSize(['tabletPC'])}) {
    width: 100%;
  }
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    width: 100%;
  }
`;

export const HeaderTextS = styled(Text)`
  padding-bottom: 10px;
  font-family: ${getThemeFont(['bold'])};
  font-size: 18px;
   
  @media (max-width: ${getScreenSize(['tabletPC'])}) {
    margin-left: 30px;
  }
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-left: 30px;
  }
`;

export const BaseBlockStyled = styled.div`
  margin: 20px 0px;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
  
  background-color: ${getThemeColor(['white'])};
`;

export const HeaderWrapper = styled(DisplayFlexS)`
  margin-top: 10px;
  align-items: center;
  @media (max-width: ${getScreenSize(['medium'])}) {
     align-items: center;
  }
`;

export const CompanyLogoWrapS = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-right: 20px;
  
  @media (max-width: ${getScreenSize(['medium'])}) {
     align-items: flex-start;
  }
`;

export const LogoWithUploadOverlayS = styled.div`
  margin: 0px auto auto;
  
  width: 70px;
  height: 70px;
  
  border-radius: 50%;
  border: 1px solid ${getThemeColor(['grayBlue'])};
  
  background: ${getThemeColor(['white'])} url(${({ logo }) => logo || NoLogoIcon}) center no-repeat;
  background-size: ${({ logo }) => logo ? '100%' : '50%'};
  
  display: flex;
  justify-content: center;
  align-items: center;
  
  ${({isGuest}) => isGuest && css`
    &:hover { 
      transition: background-color 1s linear, background-image 1s linear;
      background-color: ${getThemeColor(['greyBlueLight'])};
      background-image: none;
      
      color: ${getThemeColor(['greyViolet'])};
      font-size: ${getThemeSize(['bigText'])};
      text-align: center;
      
      cursor: pointer;
      &:after {
        content: "${t('logoText.changeLogo')}";
      }
  `} 
`;

export const TabsWrapper = styled.div`
  position: relative;
  margin-bottom: -18px;
  
  flex-direction: row;
  display: flex;
  min-width: 300px;
  width: 50%;
 
  z-index: 2;
  @media (max-width: ${getScreenSize(['medium'])}) {
    width: 100%;
    flex-direction: row;
    display: flex;    
  }

`;

export const TabsBorderWrap = styled.div`
  width: 100%;

  border-bottom: 3px solid ${getThemeColor(['grayBlue'])};
  z-index: 2;
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    width: 100%;
    flex-direction: row;
    display: flex;    
    border-bottom: none;
  }
  
`;

export const CommentWrapS = styled.div`
  width: 100%;
  margin-top: 20px;
  border-bottom: 1px solid ${getThemeColor(['grayBlue'])};
  
  &:nth-last-child(-n+2) {
    border-bottom: none;
  }
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const SelectImageTextS = styled(Text)`
  text-align: left;
  color: ${getThemeColor(['violet'])};
  font-family: ${getThemeFont(['bold'])};
  font-size: 13px;
  
  cursor: pointer;
`;

export const InputWrapper = styled.div`
  width: ${R.propOr('100%', 'width')};
  margin-bottom: 20px;
 
  @media (max-width: ${getScreenSize(['medium'])}) {
     margin-bottom: 15px;
     flex-basis: ${R.propOr('100%', 'mobileWidth')};
     width: 100%;
  }
`;

export const BottomForm = styled.div`
  padding: 20px 25px;
  margin: 0 -20px -20px -20px!important;
  border-radius: 0px 0px 3px 3px;
  background-color: ${getThemeColor(['greyBlueLight'])};
  display: flex; 
  
  @media (max-width: ${getScreenSize(['medium'])}) {
     justify-content: center;
  }
  
`;

export const Form = styled.form`
  width: 100%;
  margin-top: 10px;
`;

export const TitleInfoBlock = styled(DisplayFlexS)`
  flex-direction: column;
  margin-left: 35px;
  
  @media (max-width: ${getScreenSize(['medium'])}) {
     flex-direction: column;
     margin-left: 10px;
  }
`;
